import gql from 'graphql-tag'

export const getCases = gql`
  query($isTop: Boolean!, $isOpen: Boolean!, $paging: PagingQuery, $order: CaseOrder, $filter: CasesFilter!) {
    getCases  (
      filter: $filter,
      order: $order,
      paging: $paging,
      isTop: $isTop,
      isOpen: $isOpen
    ) {
      paging{ totalCount currentOffset currentLimit }
      cases {
        id
        inquiryName
        type
        priority
        closeDate
        openDate
        closed
        createdAt
        important 
        urgent
        ifNewProducer
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        caseManager {
          id
          username
        }
        assignedUsers {
          id
          username
        }
        recordType {
          id
          name
        }
      }
    }
  }
`

export const getCaseById = gql`
  query($caseId: Int!) {
    getCaseById(
      caseId: $caseId
    ) {
      id
      inquiryName
      type
      caseNote
      priority
      important 
      urgent
      closed
      createdAt
      updatedAt
      status
      closeDate
      openDate
      important 
      urgent
      ifNewProducer
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      recordType {
        id
        name
      }
      attachments {
        id
        type
        name
        size
        createdAt
        updatedAt
      }
      account {
        id
        name
        recordType {
          id
          name
        }
        phone
        book {
          id
          name
        }
      }
      primaryContact {
        id
        name
      }
      source {
        id
        name
      }
      assignedUsers {
        id
        username
      }
      caseManager {
        id
        username
      }
      notes {
        id
        content
        createdBy {
          id
          username
        }
        createdAt
        updatedAt
      }
      policies {
        id
        policyName
        status
        type
        cancelDate
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        closed
        createdAt
        updatedAt
        caseId
        additionalInfoStr
        installmentPlan
        billingType
        isPremiumPayOff
        isCommissionPayOff
        productCommissionOverride
        caseId
        bindDate
        payerType
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        generalAgent {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        book {
          id
          name
        }
        recordType {
          id
          name
        }
        insuranceQuote {
          id
          name
        }
        writingAgents {
          id
          username
        }
        inheritPolicies {
          fromPolicy {
            id
            policyName
          }
        }
      }
      quotes {
        id
        name
        status
        type
        originalInceptionDate
        commissionPaymentEffectiveDate
        commissionPaymentExpirationDate
        closed
        createdAt
        updatedAt
        federalEmployerIdNumber
        additionalInfoStr
        caseId
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        priorTerm {
          id
          policyName
        }
        labels {
          id
          content
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      relatedQuotes {
        id
        name
        status
        type
        originalInceptionDate
        commissionPaymentEffectiveDate
        commissionPaymentExpirationDate
        closed
        createdAt
        updatedAt
        federalEmployerIdNumber
        additionalInfoStr
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      relatedPolicies {
        id
        policyName
        status
        type
        cancelDate
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        bindDate
        payerType
        closed
        createdAt
        updatedAt
        caseId
        additionalInfoStr
        installmentPlan
        billingType
        isPremiumPayOff
        isCommissionPayOff
        productCommissionOverride
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        generalAgent {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        book {
          id
          name
        }
        recordType {
          id
          name
        }
        insuranceQuote {
          id
          name
        }
        writingAgents {
          id
          username
        }
        inheritPolicies {
          fromPolicy {
            id
            policyName
          }
        }
      }
      vehicles {
        id
        name
        vin
        year
        model
        ownership
        useage
        mileage
      }
      properties {
        id
        address
        city
        state
      }
      insureds {
        id
        name
        relationShip
        dateOfBirth
      }
      targetPolicy {
        id
        policyName
        status
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        bindDate
        payerType
        type
        closed
        createdAt
        updatedAt
        productCommissionOverride
        caseId
        additionalInfoStr
        installmentPlan
        billingType
        isPremiumPayOff
        isCommissionPayOff
        deleted
        cancelDate
        productCommissionOverride
        totalProjectedCommission
        totalProjectedPremium
        nonRenew
        generalAgent {
          id
          name
        }
        labels {
          id
          content
          color
        }
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        insuranceQuote {
          id
          name
        }
        writingAgents {
          id
          username
        }
        book {
          id
          name
        }
        inheritPolicies {
          fromPolicy {
            id
            policyName
            type
          }
        }
        labels {
          id
          content
          color
        }
      }
    }
  }
`

export const newCase = gql`
  mutation($caseInput: CaseInput!) {
    newCase(
      caseInput: $caseInput
    ) {
      id
    }
  }
`

export const editCaseById = gql`
  mutation($caseInput: CaseInput!, $caseId: Int!) {
    editCaseById(
      caseInput: $caseInput,
      caseId: $caseId
    ) {
      id
    }
  }
`

export const deleteCaseById = gql`
  mutation($caseId: Int!) {
    deleteCaseById(
      caseId: $caseId
    )
  }
`

export const assignCase = gql`
  mutation($caseId: Int!, $userIds: [Int!]!) {
    assignCase(
      userIds: $userIds,
      caseId: $caseId
    )
  }
`

export const openCase = gql`
  mutation($caseId: Int!) {
    openCase(
      caseId: $caseId
    )
  }
`

export const closeCase = gql`
  mutation($caseId: Int!) {
    closeCase(
      caseId: $caseId
    )
  }
`

export const updateCaseStatus = gql`
  mutation($caseId: Int!, $status: CaseStatus!) {
    updateCaseStatus(
      status: $status,
      caseId: $caseId
    )
  }
`

export const updateCasePriority = gql`
  mutation($caseId: Int!, $priority: Int) {
    updateCasePriority(
      priority: $priority,
      caseId: $caseId
    )
  }
`

export const newBusiness = gql`
  mutation($input: NewBusinessInput!) {
    newBusiness(
      input: $input
    ) {
      inquiryName
      account {
        id
      }
    }
  }
`

export const getCandidatePoliciesWithRecordType = gql`
  query($paging: PagingQuery, $filter: PoliciesFilter!) {
    getPolicies(
      filter: $filter,
      paging: $paging
    ) {
      policies {
        id
        policyName
        type
        recordType {
          id
          name
        }
      }
    }
  }
`

export const searchPolicies = gql`
  query($paging: PagingQuery, $filter: PoliciesFilter!) {
    getPolicies(
      filter: $filter,
      paging: $paging
    ) {
      policies {
        id
        policyName
        policyNumber
        type
        status
        recordType {
          id
          name
        }
        carrier {
          id
          name
        }
        account {
          id
        }
        primaryContact {
          id
        }
        source {
          id
        }
      }
    }
  }
`

export const newNote = gql`
  mutation($noteInput: NoteInput!) {
    newNote(
      noteInput: $noteInput
    ) {
      id
      content
    }
  }
`

export const editNote = gql`
  mutation($noteInput: NoteInput!, $noteId: Int!) {
    editNote(
      noteInput: $noteInput,
      noteId: $noteId
    ) {
      id
      content
    }
  }
`

export const deleteNoteById = gql`
  mutation($noteId: Int!) {
    deleteNoteById(
      noteId: $noteId
    )
  }
`

export const getGlobalSearchCases = gql`
  query($query: String!, $order: CaseOrder!, $paging: PagingQuery!) {
    globalSearchCases  (
      query: $query,
      order: $order,
      paging: $paging,
    ) {
      cases {
        id
        inquiryName
      }
    }
  }
`

export const getAllGlobalSearchCases = gql`
  query($query: String!, $order: CaseOrder!, $paging: PagingQuery!) {
    globalSearchCases  (
      query: $query,
      order: $order,
      paging: $paging,
    ) {
      cases {
        id
        inquiryName
        priority
        account {
          name
        }
        status
        type
        recordType {
          id
          name
        }
        lastModifiedBy {
          id
          username
        }
        caseManager {
          id
          username
        }
        assignedUsers {
          id
          username
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getCandidateCases = gql`
  query($paging: PagingQuery, $filter: CasesFilter!) {
    getCases(
      filter: $filter,
      paging: $paging,
      isTop: false,
      isOpen: true
    ) {
      cases {
        id
        inquiryName
      }
    }
  }
`

export const getCaseReport = gql`
  query($paging: PagingQuery, $query: CaseReportFilter!, $order: CaseReportOrder) {
    getCaseReport(
      query: $query,
      paging: $paging,
      order: $order
    ) {
      cases {
        id
        inquiryName
        type
        recordType {
          id
          name
        }
        account {
          id
          name
        }
        source {
          id
          name
        }
        caseManager {
          id
          username
        }
        policies {
          id
          policyName
        }
        createdAt
        closeDate
        closed
        openDate
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const exportCaseReports = gql`
  mutation($input: NewCaseExportInput!) {
    exportCaseReports(
      input: $input
    )
  }
`

export const checkPolicyIfHandling = gql`
  query($policyId: Int!) {
    checkPolicyIfHandling(policyId: $policyId) {
      ifNextPolicy
      ifHandlingCase
      nextPolicyCaseType
      handlingCase {
        id 
        inquiryName
      }
    }
  }
`

// """获取 New Cases from producer (2.0)"""
export const getNewCasesFromProducer = gql`
  query($filter: CasesFilter, $order: CaseOrder) {
    getNewCasesFromProducer  (
      filter: $filter,
      order: $order,
    ) {
      id
      ifNewProducer
      inquiryName
      type
      priority
      closeDate
      openDate
      closed
      createdAt
      step
      status
      important
      urgent
      formsite
      producerForm
    }
  }
`

export const updateNewCaseFromProducerAssignee = gql`
  mutation($caseId: Int!) {
    updateNewCaseFromProducerAssignee(
      caseId: $caseId,
    )
  }
`
